/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_InforegisterInputs */

const et_footer_inforegister = /** @type {(inputs: Footer_InforegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inforegister`)
};

const en_footer_inforegister = /** @type {(inputs: Footer_InforegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inforegister`)
};

/**
* | output |
* | --- |
* | "Inforegister" |
*
* @param {Footer_InforegisterInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_inforegister = /** @type {((inputs?: Footer_InforegisterInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_InforegisterInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_footer_inforegister(inputs)
	return en_footer_inforegister(inputs)
});